import {Button, Divider, List, Stack, Typography} from '@mui/material';
import React from 'react';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {StyledCardContent} from './styles';
import {SummaryCardSectionProps} from './types';

const {change} = translations['pt-br'].commons;

export function SummaryCardSection({
	subheader,
	primaryText,
	secondaryText,
	iconName,
	disableGutters,
	hasDivider,
	handleAction,
	hideAction,
	disablePrimaryTextFormat,
	disableSecondaryTextFormat,
	secondaryData,
	dataTagId,
}: SummaryCardSectionProps) {
	return (
		<StyledCardContent $disableGutters={disableGutters}>
			{hasDivider ? <Divider sx={{mb: 1.5, mt: -1.5}} /> : null}
			<Stack flexDirection="row" justifyContent="space-between" alignItems="center">
				<Typography variant="subheader">{subheader}</Typography>
				{!hideAction ? (
					<Button
						variant="text"
						size="small"
						onClick={handleAction}
						data-tag-id={dataTagId}>
						{change}
					</Button>
				) : null}
			</Stack>
			<List>
				<DataInfo
					primaryText={disablePrimaryTextFormat ? primaryText : formatText(primaryText)}
					iconName={iconName}
					secondaryText={secondaryText}
				/>
				{secondaryData ? (
					<DataInfo
						primaryText={
							disableSecondaryTextFormat
								? secondaryData.primaryText
								: formatText(secondaryData.primaryText)
						}
						iconName={secondaryData.iconName}
						secondaryText={secondaryData?.secondaryText}
					/>
				) : null}
			</List>
		</StyledCardContent>
	);
}
